import React from "react";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import biometryPaySprint from "./biometry-paysprint";
class TestAeps extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: '',
        }
    }
    componentDidMount() {
        biometryPaySprint.captureDeviceInfoOnLoad();
    }

    render() {

        return (
            <div>Test</div>
        )
    }

}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    aepsReduce: { aepsBiometricDtaCaptureStatus, aepsBiometricDta, checkingDriverStatus, deviceInfoUrl, captureUrl },
    miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, deviceInfo, callBackUrl }
}
) => ({
    errorMessage, loginErrorMessage, aepsBiometricDtaCaptureStatus, aepsBiometricDta, checkingDriverStatus,
    deviceInfoUrl, captureUrl,
    phone, agentInfo,
    token, clientRole, clientRequesterId, deviceInfo, callBackUrl
});


export default connect(mapStateToProps, null)(TestAeps);



